export enum PAGES {
	HOME = 'documents-review',
}

/**
 * The Document review admin's Module Federation remote: its federation name, and where Engine serves
 * its manifest from — Engine's own bucket, under remotes/documents-review/, which
 * motorway/mw-documents-processing's deploy workflow writes to.
 *
 * The manifest's URL never changes, so the deploy must upload mf-manifest.json and
 * remoteEntry.js with `Cache-Control: no-cache`; everything they point at is fingerprinted.
 */
export const REMOTE = {
	NAME: 'documents_review',
	MANIFEST_PATH: '/remotes/documents-review/mf-manifest.json',
} as const;
